import {Box} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import ChartColumnMultiple from 'src/sections/_examples/extra/chart-view/chart-column-multiple';
import RCMDashboardTable from '../RCMDashboardTable';
import {fetchChartColors} from 'src/utils/chart_utils';
import {generateYearList} from 'src/utils/helperUtils';

const RCMpaymentsComponent = ({data, chartData, ...props}: any) => {
  const [chartColors, setChartColors] = useState<any>({});
  const barChartRef = useRef<any>(null);
  const pieChartRef = useRef<any>(null);

  useEffect(() => {
    // Fetch colors after charts are rendered
    const refList: any = [
      {
        ref: barChartRef,
        type: 'bar',
        name: 'bar_chart_01'
      },
      {
        ref: pieChartRef,
        type: 'pie',
        name: 'pie_chart_01'
      }
    ];
    setTimeout(() => {
      /** Function to retrieve chart colors */
      fetchChartColors(setChartColors, refList);
    }, 500);
  }, [chartData]);

  return (
    <>
      <ChartColumnMultiple
        chartRef={barChartRef}
        height={500}
        chartOptionsObj={{
          yaxis: {
            labels: {
              formatter: function (value: any) {
                return `$${value}`; // Add the dollar symbol before the value
              }
            }
            // ,
            // title: {
            //   text: 'Revenue' // Optional: Add a title for the y-axis
            // }
          },
          plotOptions: {bar: {columnWidth: '80%'}},
          ...chartData?.bar_chart_01
        }}
        series={chartData?.bar_chart_01?.series ?? []}
      />
      {chartColors?.bar_chart_01 ? (
        <Box sx={{mt: 5}}>
          <RCMDashboardTable
            addOnColumns={['Grand Total']}
            addOnRows={['Grand Total', 'Percentage']}
            data={{
              ...chartData?.table_data_01,
              colors: chartColors?.bar_chart_01,
              groupedColumn: true,
              columnsList: [
                Object.keys(chartData?.table_data_01?.rows)[0],
                ...generateYearList(data.from_date, data.to_date)
              ],
              splitColumnForHeaderWith: '-'
            }}
            valueFormatter={'currency'}
          />
        </Box>
      ) : null}
    </>
  );
};

export default RCMpaymentsComponent;
